import React from 'react';

import Button from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter, ModalHeader } from '@qality/common-components';
import { Project } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  project: Project;
  showModal: boolean;
  onClose: () => void;
};

export const RedirectToProjectSettingsConfirmationModal: React.FC<Props> = ({
  project,
  onClose,
  showModal,
}: Props) => {
  const redirectToProjectSettings = () => {
    window.open(
      StorageOfUniqueServices.get('URLService').getProjectConfigIssueTypesUrl(
        project
      ),
      '_blank'
    );
    onClose();
  };

  return (
    <ModalTransition>
      {showModal && (
        <Modal
          onClose={onClose}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEscapePress={false}
          shouldScrollInViewport
        >
          <ModalHeader
            appearance='warning'
            title={`You have QAlity test issues in ${project.name}`}
          />
          <ModalBody>
            {`In ${project.name} there are QAlity Test issues that have to be
            turned into another issue type before you disable the QAlity Test
            issue type. To disable the QAlity Test issue type in ${project.name}
            continue with project settings.`}
          </ModalBody>
          <ModalFooter>
            <Button appearance='subtle' onClick={onClose}>
              Cancel
            </Button>
            <Button appearance='warning' onClick={redirectToProjectSettings}>
              Continue
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
